"use client"
import { useInView } from "react-intersection-observer"
import dynamic from "next/dynamic"
import SkeletonLoader from "./skeleton-best-deals"

const DynamicBestDeals = dynamic(
  () => import("./best-deals").then((mod) => mod.BestDeals),
  {
    loading: () => <SkeletonLoader />,
  }
)

export default function BestDealsWrapper() {
  const { ref, inView } = useInView({ triggerOnce: true, threshold: 0.2 })
  return (
    <div className="hidden sm:block" ref={ref}>
      {inView && <DynamicBestDeals />}
    </div>
  )
}
